import React from 'react';

import {disciplines} from './constants';
import Header from './Header';

const DisciplineTips4 = ({score}) => {
    const discipline = disciplines['4'];

    return (
        <div className={'ohs-discipline'}>
            <Header/>

            <div className={'ohs-discipline__content ohs-content-padding'}>
                <h2 className={'ohs-discipline__heading'}>{discipline.header}</h2>

                <p className={'ohs-discipline__score-text'}>{discipline[score]}</p>

                <h3 className={'ohs-discipline__tips-heading'}>Tips for Reinforcing Clarity:</h3>
                <p className={'ohs-discipline__tips-intro'}>
                    here are a few primary systems that serve to institutionalize an organization's sense of clarity:
                </p>

                <ol className={'ohs-discipline__tips-list'}>
                    <li>
                        <b>Hiring:</b>
                        <p>
                            Look beyond experience in job candidates to ensure a fit with the organization’s values and
                            culture. Ask consistent, behavioral questions of interviewees and probe for evidence that
                            they will thrive in the organization over time. Debrief collectively with all involved in
                            the hiring process to determine if any additional interviewing needs to occur.
                        </p>
                    </li>
                    <li>
                        <b>Managing performance:</b>
                        <p>
                            An employee’s performance needs to be measured beyond just the “feeling” of their direct
                            manager. When evaluating performance, use a systematic, non-bureaucratic method that reviews
                            not only progress against goals, but behavioral attributes as well. Avoid the temptation to
                            employ a generic, off-the-shelf program. Spend time developing a model that is specific and
                            customized to reinforce the organization’s clarity.
                        </p>
                    </li>
                    <li>
                        <b>Meetings:</b>
                        <p>
                            At first glance, meetings may not seem like a human system. In reality, meetings are one of
                            the most important human systems that exist within an organization. Without effective
                            meetings, an organization will waste time, make poor decisions, and leave employees
                            frustrated and resolved to work in silos. Put in place a meeting structure that delineates
                            between tactical and strategic issues so employees can properly focus. Avoid the desire to
                            fit everything into one big meeting. For additional insight about running more effective
                            meetings, see the book{' '}
                            <a className={'ohs-discipline__link'} href='https://www.tablegroup.com/product/dbm/'>
                                <i>Death by Meeting</i>
                            </a>.
                        </p>
                    </li>
                    <li>
                        <b>Rewarding:</b>
                        <p>
                            Rewards and recognition should be simple and tied to organizational clarity. Reward
                            employees for behaving according to your organization’s core values. Hold up those stellar
                            employees as examples that others should strive to emulate. Be cautious of rewarding only
                            based on financial metrics, as this may send an inconsistent message regarding the expected
                            behaviors.
                        </p>
                    </li>
                    <li>
                        <b>Dismissing:</b>
                        <p>
                            While firing employees is never enjoyable, sometimes it’s necessary to sustain the culture
                            of an organization. To avoid doing this capriciously, engage in clear and consistent
                            conversations with problem employees. When an organization retains an employee who does not
                            fit, it sends a clear message to the rest of the staff that problem behavior is acceptable.
                            This ultimately erodes trust and credibility in leaders. Ironically, the clearer leaders are
                            about expected behaviors in the hiring process, the more likely the “misfits” will opt out
                            on their own.
                        </p>
                    </li>
                </ol>
            </div>
        </div>
    );
};

export default DisciplineTips4;
